import React, { useEffect, useState } from 'react';

import IconButton from '../button/IconButton';
import CardTable from './CardTable';
import ModalForm from '../form/ModalForm';
import { Actions } from '../../../client/Actions';
import { Button, ButtonGroup, Col, Dropdown } from 'react-bootstrap';
import Table from './Table';
import LightButton from '../button/LightButton';
import { useLoaderContext } from '../loader/LoaderContext';
import TrickButton from '../button/TrickButton';
import { FaBars, FaEdit, FaInfoCircle, FaTrash } from 'react-icons/fa';
import ConfirmButton from '../button/ConfirmButton';

const FunctionalTableComponent = ({
  onDataUpdate,
  title,
  creationTitle,
  editionTitle = 'Edycja',
  width,
  api,
  withoutCreate,
  creationFields,
  shadow = true,
  editable = false,
  details = false,
  initialData,
  removable = true,
  readOnly,
  columns,
  externalReload,
  tableHeader,
  editWithPost = false,
  editWithId = false,
  header,
  className,
  editionFields,
  fromModal,
  addFromGroup,
  addFromGroupFields,
  noCard,
  editAction,
  detailsAction,
  modalSize,
  componentTitle,
  onCreated,
  deleteModalTitle,
  deleteModalDescription,
  addAsList,
  additionalButtons,
  additionalButtonsConfig,
  deleteApi,
  beforeSave,
  editApi,
  createApi,
  customCreate,
  pagination,
  onDeleted,
  onEdited,
  trick,
  toolBarButton,
  tableExport,
  apiFunction,
  forceDropdown = false
}) => {
  const { setLoader } = useLoaderContext();

  const [showModal, setShowModal] = useState(false);
  const [showAddFromGroupModal, setShowAddFromGroupModal] = useState(false);
  const [reload, setReload] = useState(false);

  const [data, setData] = useState(initialData || []);
  const [editMode, setEditMode] = useState(false);
  const [editionItem, setEditionItem] = useState();

  const loadData = () => {
    if (apiFunction) {
      setLoader(true);
      apiFunction(dataLoaded);

    } else if (api) {
      setLoader(true);
      Actions.get(api, dataLoaded);
    }
  };
  const save = (data) => {
    setLoader(true);

    if (beforeSave) {
      data = beforeSave(data);
    }

    if (editMode && !editWithPost) {
      Actions.put(
        `${editApi || api}${editWithId ? '/' : ''}${editWithId ? data.id : ''}`,
        data,
        (saved) => {
          if (onEdited) {
            onEdited(saved);
          }
          loadData();
        },
        undefined,
        setLoader
      );
    } else {
      Actions.post(createApi || api, addAsList ? [data] : data, (saved) => {
        if (onCreated) {
          onCreated(saved);
        }
        loadData();
      });
    }
  };
  
  const customDelete = (id) => {
    if (deleteApi || api) {
      setLoader(true);
      Actions.delete(
        (deleteApi || api) + '/' + id,
        {},
        () => {
          setLoader(false);
          loadData();
          if (onDeleted) {
            onDeleted();
          }
        },
        undefined,
        setLoader
      );
    } else {
      const newData = data.filter(item => item.id !== id);

      setData(newData);

    }

  };

  const dataLoaded = (newData) => {
    setData(newData);
    setLoader(false);
  };

  function closeModal() {
    setShowModal(false);
    setEditMode(false);
    setEditionItem(undefined);
  }


  const actionsColumn = {
    field: 'actions',
    label: 'Akcje',
    type: 'custom',
    width: 53,
    custom: function (column, row, navigate, additionalInformation) {
      const extraButton =
        additionalButtons && !readOnly
          ? additionalButtons(row, reload, setReload)
          : null;
      const hasDesktopActions =
        (removable && !readOnly) ||
        (editable && !readOnly) ||
        details ||
        !!extraButton;

      if (!hasDesktopActions) {
        return null;
      }

      return (
        <div className="d-flex align-items-center gap-2">
          {/* Desktop buttons */}
          <div className={`d-none ${!forceDropdown && 'd-md-flex'} gap-2`}>
            {removable && !readOnly && (
              <ConfirmButton
                onConfirm={() => customDelete(row.id)}
                confirmTitle={deleteModalTitle || 'Usunięcie'}
                confirmDescription={deleteModalDescription || 'Czy napewno chcesz usunąć ten element?'}
                variant={'secondary'}
                saveVariant={'danger'}
              > Usuń
              </ConfirmButton>

            )}
            {editable && !readOnly && (
              <LightButton
                size="sm"
                onClick={() => {
                  if (editAction) {
                    editAction(row.id)
                  }
                  setEditMode(true);
                  setShowModal(true);
                  setEditionItem(row);
                }}
              >
                Zmień
              </LightButton>
            )}
            {details && (
              <LightButton
                onClick={() => detailsAction(row.id)}

              >
                Szczegóły
              </LightButton>
            )}
            {extraButton}
          </div>

          {/* Mobile dropdown */}
          <div className={`${!forceDropdown && 'd-md-none'} `}>
            <Dropdown as={ButtonGroup}>
              <Button variant="outline-secondary" size="md">
                <FaBars />
              </Button>
              <Dropdown.Toggle split variant="outline-secondary" size="md" />
              <Dropdown.Menu align="end">
                {removable && !readOnly && (
                  <Dropdown.Item onClick={() => customDelete(row.id)}>
                    <FaTrash className="me-2" /> Usuń
                  </Dropdown.Item>
                )}
                {editable && !readOnly && (
                  <Dropdown.Item
                    onClick={() => {
                      setEditMode(true);
                      setShowModal(true);
                      setEditionItem(row);
                    }}
                  >
                    <FaEdit className="me-2" /> Edytuj
                  </Dropdown.Item>
                )}
                {details && (
                  <Dropdown.Item onClick={() => detailsAction(row.id)}>
                    <FaInfoCircle className="me-2" /> Szczegóły
                  </Dropdown.Item>
                )}

                {additionalButtonsConfig ?
                  additionalButtonsConfig(row)
                    .filter(c => c.show)
                    .map(c => {
                      return <Dropdown.Item onClick={c.onClick}>
                        {c.icon} {c.label}
                      </Dropdown.Item>;
                    })
                  :
                  (extraButton &&
                    React.cloneElement(extraButton, {
                      as: Dropdown.Item,
                      className: '', // usuwa np. btn-outline-* z LightButton
                      variant: undefined,
                      size: undefined,
                      padding: undefined
                    }))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      );
    }
  };


  useEffect(() => {
    console.log('onDataUpdate ', data);
    if (onDataUpdate) {
      onDataUpdate(data);
    }
  }, [data]);

  // useEffect(() => {
  //   if (initialData) {
  //     setData(initialData);
  //   }
  // }, [initialData]);

  useEffect(loadData, [api, reload, externalReload]);

  function prepareTitle() {
    return (
      <div className={'d-flex justify-content-between align-items-center'}>
        {componentTitle ? (
          componentTitle
        ) : (
          <div className="mt-2 d-flex gap-2">
            {title}
            {trick && <TrickButton text={trick} />}
          </div>
        )}

        {!readOnly && (creationFields || customCreate || toolBarButton) && (
          <div>
            {addFromGroup && (
              <IconButton
                variant="outline-primary"
                onClick={() => setShowAddFromGroupModal(true)}
                icon="fa-layer-group"
                className={'rounded-circle me-2'}
                tooltip="Dodaj z grupy"
              />
            )}

            {!withoutCreate && (
              <LightButton
                onClick={() =>
                  customCreate ? customCreate() : setShowModal(true)
                }
              >
                Dodaj
              </LightButton>
            )}
            {toolBarButton}
          </div>
        )}
      </div>
    );
  }

  function onSave(newItem, onSaved) {
    if (createApi) {
      save(newItem);
    } else if (api) {
      save(newItem);
    } else {
      const toAdd = { ...newItem };
      toAdd.tmpId = Math.floor(Math.random() * 101010);

      if (data) {
        setData([...data, toAdd]);
      } else {
        setData([toAdd]);
      }
    }
    onSaved();
  }

  function onAddFromGroup(groupForm, onSaved) {
    Actions.post(api, groupForm.operatingParameterTemplates, loadData);

    onSaved();
  }

  return (
    <>
      <>
        {noCard && (
          <Col md={width} className={className}>
            <Table
              shadow={shadow}
              tittle={prepareTitle(title)}
              width={width}
              withoutHeader={!header}
              className={className}
              setLoader={setLoader}
              tableHeader={tableHeader}
              columns={
                (details || editable || removable || additionalButtons) &&
                  (readOnly ? details : true)
                  ? columns.concat([actionsColumn])
                  : columns
              }
              initData={data}
              reload={reload}
              pagination={pagination}
            />
          </Col>
        )}
        {!noCard && (
          <CardTable
            shadow={shadow}
            tittle={prepareTitle()}
            // componentTitle={componentTitle}
            width={width}
            withoutHeader={!header}
            className={className}
            setLoader={setLoader}
            tableHeader={tableHeader}
            columns={
              (details || editable || removable || additionalButtons) &&
                (readOnly ? details : true)
                ? columns.concat([actionsColumn])
                : columns
            }
            initData={data}
            reload={reload}
            tableExport={tableExport}
            pagination={pagination}
          />
        )}
        {showModal && (
          <ModalForm
            modalClassName={fromModal ? 'second-modal' : ''}
            open={showModal}
            setOpen={closeModal}
            setLoader={setLoader}
            size={modalSize || 'md'}
            initialData={editionItem}
            title={editMode ? editionTitle : creationTitle}
            fields={
              editMode && editionFields
                ? editionFields(editionItem)
                : creationFields
            }
            customSave={onSave}
            onFinish={() => setReload(!reload)}
          />
        )}
        {showAddFromGroupModal && (
          <ModalForm
            modalClassName={fromModal ? 'second-modal' : ''}
            open={showAddFromGroupModal}
            setOpen={setShowAddFromGroupModal}
            setLoader={setLoader}
            size={'xl'}
            title={'Dodanie parametrów z grupy'}
            fields={addFromGroupFields}
            customSave={onAddFromGroup}
            onFinish={() => setReload(!reload)}
            buttonsConf={{
              save: 'Dodaj',
              cancel: 'Anuluj'
            }}
          />
        )}
      </>
    </>
  );
};

export default FunctionalTableComponent;
